import { render, staticRenderFns } from "./ModernSampleList.vue?vue&type=template&id=352a07f4&scoped=true"
import script from "./ModernSampleList.vue?vue&type=script&lang=js"
export * from "./ModernSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a07f4",
  null
  
)

export default component.exports